<template>
  <div>
    <a style="color: #2c2c2c;" v-for="(item,index) in orderReturnList" :key="index" :href="'/#/spd/orderReturnDetail?returnNo='+item.returnNo+'&status='+item.status">
      <div v-for="(stats,index) in status" :key="index">
        <div class="whiteBackground">
          <div>
            <van-icon class="IconByLeft" name="orders-o"/>
            <label class="fontByLeft">{{ item.createTime }}</label>
            <label class="byRight">{{ item.status }}</label>
          </div>
          <div>
            <van-divider class="clear" :style="{borderColor: '#A9A9A9', padding: '0 16px'}"/>
          </div>
          <div>
            <label class="orderNumber">{{ item.returnNo }}</label>
          </div>
          <div class="Specifications">
            <label style="margin-right: 30px">品规:{{ item.drugNumber }}</label>
            <label>总数量:{{ item.totalNumber }}</label>
          </div>
          <div>
            <label class="Specifications">澳洋医院-{{ item.createBy }}</label>
            <van-tag class="byRight2" type="primary" text-color="#AFEEEE">{{ item.type }}</van-tag>
          </div>
        </div>
      </div>
    </a>

  </div>
</template>

<script>
import api from "@/axios/api";
import {mapGetters, mapActions} from "vuex";

export default {
  name: "orderItems",
  computed: {
    ...mapGetters(["token"])
  },
  watch: {
    token: {
      immediate: true,
      handler: function(val) {
        //this.getOrderReturnItems(this.searchValue);
        if (val) {
          this.getOrderReturnItems(this.searchValue);
        }
      }
    },
    flag: {
      immediate: true,
      handler: function(val) {
        this.localFlag = this.flag;
      }
    },
  },
  props:{
    activeName:{
      type: String,
      default: '',
      required: false
    },
    flag:{
      type:String,
      default: 'wait',
      required: true
    },
    searchValue:{
      type:String,
      required:true
    }
  },
  data() {
    return {
      orderReturnList: [],
      list: "",
      status:[
        "待提交"
      ],
      localFlag:""
    }
  },
  url: {
      waitSureList:'/spd/api/ehome/return/getReturnOrderList'
  },
  methods: {
    getOrderReturnItems(returnNo) {
      let param = {
        returnNo:returnNo
      };
      console.log("flag:"+this.flag);
      console.log("localFlag:"+this.localFlag);
      api.getOrderReturnItems(param).then((res) => {
        if (this.localFlag!=="all"){
          this.orderReturnList = [];
          this.orderReturnList.length = 0;
          for (let i=0;i<res.result.length;i++){
             if (res.result[i].status === "待提交"){
               this.orderReturnList.push(res.result[i]);
             }
          }
        }else {
          this.orderReturnList = [];
          this.orderReturnList.length = 0;
          this.orderReturnList = res.result;
        }
      });
    }
  },
  mounted(){

  },
  created() {

  }
}
</script>

<style scoped>
.whiteBackground {
  background-color: white;
  margin-top: 2%;
  margin-left: 15px;
  margin-right: 15px;
  padding-bottom: 15px;
  overflow: hidden;
}

/*靠左居中*/
.IconByLeft {
  float: left;
  margin-left: 4%;
  margin-top: 2%;
}

.fontByLeft {
  float: left;
  margin-left: 2%;
  margin-top: 2%;
}

.orderNumber {
  float: left;
  margin-left: 6%;
  font-weight: lighter;
  font-size: 120%;
}

.byRight {
  float: right;
  margin-right: 7%;
  margin-top: 1%;
}

.byRight2 {
  float: right;
  margin-right: 1%;
  margin-top: 1%;
}

.Specifications {
  clear: both;
  float: left;
  margin-left: 6%;
  margin-top: 1%;
  font-size: 80%;
  color: #686464;
}

.clear {
  clear: both;
}

</style>



// WEBPACK FOOTER //
// src/spd/orderItems.vue